import { render, staticRenderFns } from "./BFormProject.vue?vue&type=template&id=3494f81e&scoped=true&"
import script from "./BFormProject.vue?vue&type=script&lang=js&"
export * from "./BFormProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494f81e",
  null
  
)

export default component.exports